export default import.meta.ROLLDOWN_FILE_URL_a$fOox5kOrvoak3$2sVNlg